import { KnBrAddToCartModule } from './../../kn-br-product/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrQuickEntryComponent } from './kn-br-quick-entry.component';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrAddToQuoteModule } from 'src/app/kn-br-product/kn-br-add-to-quote/kn-br-add-to-quote.module';
import { KnBrDirectiveModule } from 'src/app/shared/directive/kn-br-directive.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        KnBrAddToCartModule,
        KnBrAddToQuoteModule,
        KnBrDirectiveModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrQuickEntryComponent: {
                    component: KnBrQuickEntryComponent,
                },
            },
        } as CmsConfig),
        RouterModule.forChild([
            {
                data: { pageLabel: '/quick-entry', cxRoute: 'quickEntry' },
                path: null,
                canActivate: [AuthGuard, CmsPageGuard],
                component: PageLayoutComponent,
            },
        ]),
        ConfigModule.withConfig({
            routing: {
                routes: {
                    quickEntry: {
                        paths: ['quick-entry'],
                    },
                },
            },
        } as RoutingConfig),
        KnBrQuickEntryComponent,
    ],
})
export class KnBrQuickEntryModule {}
